<template>
    <div class="bg-white border border-gray-300 rounded-lg">
        <slot></slot>
    </div>
</template>

<script>
export default {
    //
}
</script>
